import { useMemo } from 'react';

import {
	useCfind4473CreationFocusedNav,
	loading,
	d0,
	d1,
} from '@confluence/experiment-cfind-4473-creation-focused-nav/entry-points/useCfind4473CreationFocusedNav.ts';

import type { MenuId } from './useMenuItems.ts';

export type PlatformCustomization = {
	menuId: MenuId;
	visible: boolean;
};

export const usePlatformCustomizationsWithSimplifyNav = (
	platformCustomizations: Array<PlatformCustomization>,
) => {
	const { navCustomization } = useCfind4473CreationFocusedNav(true);
	const platformCustomizationsWithSimplifyNav = useMemo(() => {
		let customizedForExperiment: typeof platformCustomizations;
		if (navCustomization === loading) {
			customizedForExperiment = [
				{ menuId: 'recent', visible: false },
				{ menuId: 'starred', visible: false },
				{ menuId: 'companyHubShortcut', visible: false },
				{ menuId: 'teamsShortcut', visible: false },
				{ menuId: 'templates', visible: false },
			];
		} else if (navCustomization === d0) {
			customizedForExperiment = [
				{ menuId: 'recent', visible: false },
				{ menuId: 'starred', visible: false },
				{ menuId: 'companyHubShortcut', visible: false },
				{ menuId: 'teamsShortcut', visible: false },
				{ menuId: 'templates', visible: true },
			];
		} else if (navCustomization === d1) {
			customizedForExperiment = [{ menuId: 'templates', visible: true }];
		} else {
			customizedForExperiment = [];
		}
		// IDs of menu items whose visibility has been customized by the user
		const customizedMenuIds = new Set(platformCustomizations.map((item) => item.menuId));
		const itemsToCustomize = customizedForExperiment.filter(
			(item) => !customizedMenuIds.has(item.menuId),
		);
		// For users in simplify nav, hide items that the user has not explicitly chosen to show
		return [...platformCustomizations, ...itemsToCustomize];
	}, [platformCustomizations, navCustomization]);
	return { platformCustomizationsWithSimplifyNav };
};
